import AllComments from "../components/AllComments";

const AllCommentsPage = () => {
  document.title = "Все комментарии | Кампания из Эвенглена";
  return <AllComments />;
};

export default AllCommentsPage;
